import React from 'react';
import {AccessibleToStudentsRadioGroup} from './AccessibleToStudentsRadioGroup';

export const AccessibleToStudentsWithInfoRadioGroup = () => {
  return (
    <AccessibleToStudentsRadioGroup infoText="If you choose ‘no’ the resource would still be available for teachers and volunteers" />
  );
};
